'use client';

import React from 'react';

interface SchemaInjectorProps {
  schemas: Record<string, unknown>[];
}

const SchemaInjector: React.FC<SchemaInjectorProps> = ({ schemas }) => {
  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={`schema-${index}`}
          id={`schema-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      ))}
    </>
  );
};

export default SchemaInjector;
